import LocalizationStore from '../Stores/LocalizationStore'
import { Credit } from './Questionnaire'

export interface IHistoryItem {
    'userId': 'string',
    'userName': 'string',
    'status': number,
    'id': 'string',
    'createDate': string,
    'updateDate': string
}

export interface IEventHistoryItem {
    id: string
    createDate: string
    userName: string
    status: TroubleEventStatus
}

export class EventHistoryItem implements IEventHistoryItem {
    id: string
    createDate: string
    userName: string
    status: TroubleEventStatus
}

export interface ITroubleEventSimple {
    id: string
    createDate: string
    endDate: string
    type: number
    status: number
    assignedUserId: string
    assignDate: string
}

export interface ITroubleEvent extends ITroubleEventSimple {
    creditNumber: string
    historyItems: Array<IHistoryItem>
    questionnaire: any
    credit: Credit
}

export class TroubleEvent implements ITroubleEvent {
    id: string
    createDate: string
    endDate: string
    creditNumber: string
    type: number
    status: number
    assignedUserId: string
    assignDate: string
    historyItems: Array<IHistoryItem>
    questionnaire: any
    credit: Credit

    // constructor(id: string) {
    //     let a = _.cloneDeep(obj)
    //     this.id = obj['id']
    //     this.createDate = obj['createDate']
    //     this.creditNumber = obj['creditNumber']
    //     this.type = Number(obj['type'])
    //     this.status = Number(obj['status'])
    //     this.assignedUserId = obj['assignedUserId']
    //     this.assignDate = obj['assignDate']
    //     this.endDate = obj['endDate']
    //     this.questionnaire = obj['questionnaire']
    //     this.penalty = obj['penalty']
    // }
}

export enum TroubleEventType {
    Sms = 0,
    Call = 1,
    Collector = 2,
    Lawyer = 3,
    HardCall = 4,
    SmsBeforeResponsibility = 5,
    Died = 6,
    Fraud = 7,
    AutoCall = 8,
    AutoCallBeforeResponsibility = 9
}

export function getTroubleEventTypeText(type: number): string {
    const localizationStore = LocalizationStore.getInstance()

    switch (type) {
        case TroubleEventType.Sms:
            return localizationStore!.t!('Sms')
        case TroubleEventType.Call:
            return localizationStore!.t!('Call')
        case TroubleEventType.Collector:
            return localizationStore!.t!('Collector')
        case TroubleEventType.Lawyer:
            return localizationStore!.t!('Lawyer')
        case TroubleEventType.HardCall:
            return localizationStore!.t!('HardCall')
        case TroubleEventType.SmsBeforeResponsibility:
            return localizationStore!.t!('SmsBeforeResponsibility')
        case TroubleEventType.Died:
            return localizationStore!.t!('Died')
        case TroubleEventType.Fraud:
            return localizationStore!.t!('Fraud')
        case TroubleEventType.AutoCall:
            return localizationStore!.t!('AutoCall')
        case TroubleEventType.AutoCallBeforeResponsibility:
            return localizationStore!.t!('AutoCallBeforeResponsibility')
        default: return `type ${type}`
    }
}

export enum TroubleEventStatus {
    New = 0,
    InProgress = 1,
    Resolved = 2,
    NotResolved = 3,
    Expired = 4
}

export function getEventStatusText(status: number): string {
    const localizationStore = LocalizationStore.getInstance()

    switch (status) {
        case TroubleEventStatus.New:
            return localizationStore!.t!('New')
        case TroubleEventStatus.InProgress:
            return localizationStore!.t!('Assigned')
        case TroubleEventStatus.Resolved:
            return localizationStore!.t!('Resolved')
        case TroubleEventStatus.NotResolved:
            return localizationStore!.t!('NotResolved')
        case TroubleEventStatus.Expired:
            return localizationStore!.t!('Expired')
        default: return `status ${status}`
    }
}

export function getTroubleEventStatusClass(status: TroubleEventStatus) {
    switch (status) {
        case TroubleEventStatus.New:
            return 'new'
        case TroubleEventStatus.InProgress:
            return 'in-progress'
        case TroubleEventStatus.Resolved:
            return 'resolved'
        case TroubleEventStatus.NotResolved:
            return 'not-resolved'
        case TroubleEventStatus.Expired:
            return 'expired'
        default: return `new`
    }
}

export function getTroubleEventStatusText(status: TroubleEventStatus) {
    switch (status) {
        case TroubleEventStatus.New:
            return ls.t('new')
        case TroubleEventStatus.InProgress:
            return ls.t('in-progress')
        case TroubleEventStatus.Resolved:
            return ls.t('resolved')
        case TroubleEventStatus.NotResolved:
            return ls.t('not-resolved')
        case TroubleEventStatus.Expired:
            return ls.t('expired')
        default: return ls.t('new')
    }
}

const ls = LocalizationStore.getInstance()

export function getTroubleEventFormScheme(): any {
    return {
        'title': ls.t!('TroubleEvent'),
        'type': 'object',
        'properties': {
            'creditNumber': {
                'title': ls.t!('creditNumber'),
                'type': 'string'
            },
            'userId': {
                'title': ls.t!('userId'),
                'type': 'string'
            },
            'type': {
                'title': ls.t!('troubleEventType'),
                'type': 'number',
                'enum': [
                    TroubleEventType.Sms,
                    TroubleEventType.Call,
                    TroubleEventType.Collector,
                    TroubleEventType.Lawyer,
                    TroubleEventType.HardCall,
                    TroubleEventType.SmsBeforeResponsibility,
                    TroubleEventType.Died,
                    TroubleEventType.Fraud,
                    TroubleEventType.AutoCall,
                    TroubleEventType.AutoCallBeforeResponsibility
                ],
                'enumNames': [
                    ls.t!('Sms'),
                    ls.t!('Call'),
                    ls.t!('Collector'),
                    ls.t!('Lawyer'),
                    ls.t!('HardCall'),
                    ls.t!('SmsBeforeResponsibility'),
                    ls.t!('Died'),
                    ls.t!('Fraud'),
                    ls.t!('AutoCall'),
                    ls.t!('AutoCallBeforeResponsibility')
                ]
            },
            'status': {
                'title': ls.t!('troubleEventStatus'),
                'type': 'number',
                'enum': [
                    TroubleEventStatus.New,
                    TroubleEventStatus.InProgress,
                    TroubleEventStatus.Resolved,
                    TroubleEventStatus.NotResolved,
                    TroubleEventStatus.Expired
                ],
                'enumNames': [
                    ls.t!('New'),
                    ls.t!('InProgress'),
                    ls.t!('Resolved'),
                    ls.t!('NotResolved'),
                    ls.t!('Expired')
                ]
            }
        }
    }
}

export const troubleEventFormUIScheme = {
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/TroubleEvent.tsx